var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      staticClass: "grey lighten-5 pa-0 notes-print-preview",
      attrs: { fluid: "" },
    },
    [
      _c("v-row", { attrs: { "no-gutters": "" } }, [
        _c(
          "div",
          { staticStyle: { width: "100%" } },
          [
            _c(
              "v-container",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isLoading,
                    expression: "!isLoading",
                  },
                ],
                staticClass: "content-container container-height",
                class: !_vm.isMobilePort ? "px-5" : "",
                attrs: { fluid: "" },
              },
              [
                _c(
                  "v-overlay",
                  { attrs: { value: _vm.isLoading, absolute: "" } },
                  [
                    _c("v-progress-circular", {
                      attrs: { indeterminate: "", size: "64" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("default-content-section-controller", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.contentSections.length,
                      expression: "contentSections.length",
                    },
                  ],
                  attrs: {
                    renderToolbar: false,
                    "content-sections": _vm.contentSections,
                    "is-notes-section-expanded": true,
                    "show-all-bookmarks": true,
                    showNoteControlMenu: false,
                    customUserBookmarksSorOrders:
                      _vm.getCustomUserBookmarksSortOrders(),
                  },
                }),
                _vm._v(" "),
                !_vm.isLoading && !_vm.contentSections.length
                  ? _c(
                      "v-row",
                      { attrs: { justify: "center" } },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "text-center",
                            attrs: { cols: "12", sm: "4" },
                          },
                          [
                            _c(
                              "v-icon",
                              { attrs: { large: "", color: "primaryMedium" } },
                              [_vm._v("mdi-bookmark-multiple-outline")]
                            ),
                            _vm._v(" "),
                            _c(
                              "h3",
                              {
                                staticClass: "text-h6 font-weight-medium mt-2",
                              },
                              [_vm._v("No notes or bookmarks found here")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "text-body-1 text--secondary mt-2",
                              },
                              [
                                _vm._v(
                                  "\n                            Try clearing your filters. Or try bookmarking sections and adding notes to get started.\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                staticClass: "mt-2",
                                attrs: {
                                  outlined: "",
                                  color: "primary",
                                  href: "https://support.iccsafe.org/ht_kb/digital-codes/how-to-create-notes/",
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  "Learn About Notes\n                        "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm.isLoading
              ? _c(
                  "v-container",
                  {
                    staticClass: "content-container container-height",
                    attrs: { fluid: "" },
                  },
                  [
                    _c(
                      "loading",
                      [
                        _c(
                          "v-container",
                          { staticStyle: { "max-width": "400px" } },
                          [
                            _c("v-row", { staticClass: "justify-center" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-h6 font-weight-medium mb-2",
                                },
                                [
                                  _vm._v(
                                    "\n                                Preparing your print job...\n                            "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("v-row", { staticClass: "justify-center" }, [
                              _c("span", { staticClass: "grey--text" }, [
                                _vm._v(
                                  "\n                                This may take a moment, especially for larger sections/notes.\n                                If it's taking longer than expected, please re-filter to reduce the amount of sections.\n                            "
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }